import React from 'react';
import {Route, BrowserRouter, Switch , Redirect} from 'react-router-dom'
import Promo from './modules/Promo';
import PromoFb from './modules/PromoFb';
import Recipe from './modules/Recipe';
import Store from './modules/Store';
import NotFound from './components/pages/NotFound';
import NotPermissions from './components/pages/NotPermissions';
import Success from './components/pages/Success';


  export default function Routes() {
    return (
      <BrowserRouter>
        <div>
          <Route path='/'>
            <Switch>
               <Route path='/recipe/:token/' component={Recipe} />
               <Route path='/promo/:token' component={Promo} />
               <Route path='/market/:country/:products_id/:coords/:query/:copy/:subcopy/:token?/:coupon_code?' component={Store} />
               <Route path='/fb/promo/:token/' component={PromoFb} />
               <Route path='/403' component={NotPermissions}/>
               <Route path='/success' component={Success}/>
               <Route path='/404' component={NotFound} />
               <Redirect from='*' to='/404'/>
            </Switch>
         </Route>
       </div>
     </BrowserRouter>
    );
  }



// WEBPACK FOOTER //
// ./src/routes.js